import { SelectChangeEvent } from "@mui/material";
import React, { FC } from "react";
import { SingleFilter } from "./singleFilter";
import { IconCode } from "../../../../utils/icons";
import { getFilterProps } from "./helper";
import { ContentCodeOptions } from "../../../../types/sharedFormTypes";

interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  queryFilters?: any;
}

export const ContentCodeFilter: FC<Props> = ({ onFilterSelect, ...rest }) => (
  <SingleFilter
    {...rest}
    {...getFilterProps(ContentCodeOptions, "contentCode")}
    updateSearch={onFilterSelect}
    icon={IconCode}
  />
);
